$(document).ready(() => {
  let currentURL = window.location.href;
  var targetNode = document.body;

  $('.htop .login a').click(function(e) {
    e.preventDefault()
    window.location.reload()

    setTimeout(()=>{
      window.location.href = '/account/login#login';
    },300)

  });

  // Или через определённое время (например, 5 секунд)

  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(function(mutationsList, observer) {
    // Iterate through the mutations
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if the desired element has appeared
        if ($('.CustomerLoginForm .errors a').length > 0) {
          // Execute the code
          $('.CustomerLoginForm .errors a').attr('href', '#recover').addClass('RecoverPassword');

          var newUrl = currentURL.replace('?new=true', '');

          // Update the URL in the browser without reloading the page
          history.replaceState(null, '', newUrl);
          // Optionally disconnect the observer if no longer needed
          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });

  if (currentURL.indexOf('?new') !== -1 && !$('#customer_login .errors li').length){
    $('.CustomerLoginForm span.register-info').show()
    $('#login').show()

  }else{
    $('.CustomerLoginForm span.register-info').hide()
    $('#login').show()
  }

  $('.CustomerLoginForm .errors a').on('click',function (e){
    e.preventDefault()
    $('.CustomerLoginForm').hide()
    $('.RecoverPasswordForm').show()
    console.log(123123)
  })

  if (currentURL.indexOf('?done') !== -1){
    $('.CustomerLoginForm span.recover-info').show()
    $('#login').show()
  }else{
    $('.CustomerLoginForm span.recover-info').hide()
  }



  if (currentURL.indexOf('?order') !== -1) {
    $('.account-info').hide()
    $('.account-orders').show()

    $('.account-nav ul li a').removeClass('active')
    $('.account-nav ul li:first-child a').addClass('active')
  }else{
    $('.account-info').show()
    $('.account-orders').hide()

    $('.account-nav ul li a').removeClass('active')
    $('.account-nav ul li:nth-child(3) a').addClass('active')
  }

  if(currentURL.indexOf('/addresses') !== -1){
    $('.account-nav ul li a').removeClass('active')
    $('.account-nav ul li:nth-child(2) a').addClass('active')
  }

  $('.account-addresses__billing .edit-button').on('click',function (){
    const id = $(this).attr('data-address-id')
    $(`.address-edit[data-id=${id}]`).addClass('open')
  })

  $('.account-address__add').on('click',function (){
    $('.address-add').addClass('open')
  })
  $('.button-cancel,.button-save').on('click',function (){
    $('.address-edit').removeClass('open')
    $('.address-add').removeClass('open')
  })



})